"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTRACT_OPTIONS_TO_CHECK = exports.ContractOptions = void 0;
var ContractOptions;
(function (ContractOptions) {
    ContractOptions["HighFidelity"] = "high fidelity";
})(ContractOptions || (exports.ContractOptions = ContractOptions = {}));
exports.CONTRACT_OPTIONS_TO_CHECK = Object.values(ContractOptions);
